//import 'ol/ol.css';
import { INode, FeatureType, ICAMSKey, OrderDirection, IAPIResult, TextPack, CloseFormEnum } from '../Shared/Models/UtilityModels';
import * as toastr from "toastr";
import { Utilities } from '../Shared/Utility/Utilities';
import * as events from '../Shared/Bus/Bus';
import { Photos } from '../Shared/Photos/Photos';

enum jqc {
    placeholder_for_modals = '#placeholder-for-modals',
    CAMSMainPage_LeftPanels = '#CAMSMainPage_LeftPanels',
    CAMSMainPage_RightPanels = '#CAMSMainPage_RightPanels',
    CAMSMainToolbar_Container = '#CAMSMainToolbar_Container',

    taskManagementRecordListTaskEditContainer ='#taskManagementRecordListTaskEditContainer',
    taskManagementTaskEditCloseBtn = '#taskManagementTaskEditCloseBtn',
    taskManagementOpenParentFormBtn = '#taskManagementOpenParentFormBtn',
    taskManagementActivityBtn = '#taskManagementActivityBtn',
    taskManagementContactListBtn = '#taskManagementContactListBtn',
    RequiresInspection = '#RequiresInspection',
    taskManagementTaskEditInspectionContainer = '#taskManagementTaskEditInspectionContainer',
    taskManagementTaskEditReviewContainer = '#taskManagementTaskEditReviewContainer',
    taskManagementEditForm = '#taskManagementEditForm',
    taskManagementSubmitBtn = '#taskManagementSubmitBtn',
    taskManagementAssignBtn = '#taskManagementAssignBtn',
    taskManagementCancelBtn = '#taskManagementCancelBtn',
    taskManagementDeleteBtn = '#taskManagementDeleteBtn',
    taskManagementRecordListTreeResults = '#taskManagementRecordListTreeResults',
    taskManagementRecordListShowing ='#taskManagementRecordListShowing',
    taskManagementRecordListNumberCheckedBtn = '#taskManagementRecordListNumberCheckedBtn',
    taskManagementTaskGroupEditCloseBtn = '#taskManagementTaskGroupEditCloseBtn',
    taskGroupManagementActivityBtn = '#taskGroupManagementActivityBtn',
    taskGroupManagementContactListBtn = '#taskGroupManagementContactListBtn',
    taskGroupManagementEditForm = '#taskGroupManagementEditForm',
    taskGroupManagementSubmitBtn = '#taskGroupManagementSubmitBtn',
    taskGroupManagementCancelBtn = '#taskGroupManagementCancelBtn',
    taskGroupManagementEditView_ContactTypeLUTList = '#taskGroupManagementEditView_ContactTypeLUTList',
    taskGroupManagementEditView_contactSearch = '#taskGroupManagementEditView_contactSearch',

    taskManagementListPinBtn = '#taskManagementListPinBtn',
    taskManagementShowCustomFilterBtn = '#taskManagementShowCustomFilterBtn',
    taskManagementCustomFilterContainer = '#taskManagementCustomFilterContainer',

    taskManagementEditView_assignToField = '#taskManagementEditView_assignToField',
    taskGroupManagementEditView_assignToField = '#taskGroupManagementEditView_assignToField',
    taskGroupManagementTaskEditInspectionContainer = '#taskGroupManagementTaskEditInspectionContainer',
    taskGroupManagementTaskEditReviewContainer = '#taskGroupManagementTaskEditReviewContainer',

    taskManagementEditView_timeEst = '#taskManagementEditView_timeEst'
}

export class TaskManagement_EditTask {

    // ----------------------------------------------------------- //
    // GLOBAL VARS
    private photos: Photos = new Photos();

    // ----------------------------------------------------------- //

    // ----------------------------------------------------------- //
    // Defaults

    // ----------------------------------------------------------- //
    //Constructor
    public constructor() {
        this.initEvents();
    }

    private initEvents = (): void => {
        const self = this;
    }

    // ----------------------------------------------------------- //
    // OPEN PANELS
    public openTaskEditForm = (taskID: string, callback: Function): void => {
        const self = this;
        
        Utilities.GetControl(jqc.taskManagementRecordListTaskEditContainer).load(window.G_SITEFOLDERNAME +'/TaskManagement/TaskEdit', { taskID: taskID }, function (response, status, xhr) {
            Utilities.UnBlockUI(Utilities.GetControl(jqc.taskManagementRecordListTaskEditContainer));

            //initialise photo uploader
            self.photos.setupUploader(jqc.taskManagementRecordListTaskEditContainer);

            // Override what the photo click does
            setTimeout(function () {
                $('#taskManagementEditForm #camsLibraryLinkContainer .card').off('click');
                $('#taskManagementEditForm #camsLibraryLinkContainer .card').on('click', function () {
                    var index = $('#taskManagementEditForm #camsLibraryLinkContainer .card').index($(this));
                    var imgs = $('#taskManagementEditForm #camsLibraryLinkModalGallery').find('img');

                    var url = imgs[index].getAttribute('src');
                    self.photos.showPhotoModal(url);
                });
            }, 500);

            
            Utilities.GetControl(jqc.taskManagementTaskEditCloseBtn).on('click', function () {
                if (originalFormData !== Utilities.GetControl(jqc.taskManagementEditForm).serialize()) {
                    Utilities.CloseFormWithSaveFirstPrompt().then(r => {
                        if (r == CloseFormEnum.DisregardAndProceed) callback(false);
                        else if (r == CloseFormEnum.SaveAndProceed) callback(false);
                    });
                }
                else {
                    callback(false);
                }
            });

            Utilities.GetControl(jqc.taskManagementOpenParentFormBtn).on("click", function () {
                const data: ICAMSKey = $(this).data("parentref");
                if (data.featureType == FeatureType.Maint) {
                    events.bus.publish(events.eventOpenMaintEditPanel(data));
                }
                else if (data.featureType == FeatureType.Route) {
                    events.bus.publish(events.eventOpenRouteEditPanel(data));
                }
                else if (data.featureType == FeatureType.Infra) {
                    events.bus.publish(events.eventOpenInfraEditPanel([data,null]));
                }
                else if (data.featureType == FeatureType.Land) {
                    events.bus.publish(events.eventOpenLandEditPanel(data));
                }
                this.blur();
            });

            // Set the assign to value
            var assignToTypeDescr_field = Utilities.GetControl(jqc.taskManagementEditForm + ' [name="AssignedToTypeDescr"]');
            var assignToListName_field = Utilities.GetControl(jqc.taskManagementEditForm + ' [name="AssignedToListName"]');
            if (assignToListName_field.val() != "") {
                Utilities.GetControl(jqc.taskManagementEditView_assignToField).val(assignToListName_field.val());
                Utilities.GetControl(jqc.taskManagementEditForm + ' [name="SendNotification"]').prop('disabled', false);
            }
            else {
                Utilities.GetControl(jqc.taskManagementEditView_assignToField).val(assignToTypeDescr_field.val());
                Utilities.GetControl(jqc.taskManagementEditForm + ' [name="SendNotification"]').prop('disabled', true);
            }

            Utilities.GetControl(jqc.taskManagementAssignBtn).on("click", function () {
                const data: ICAMSKey = { code: taskID, featureType: FeatureType.Task };
                if (originalFormData !== Utilities.GetControl(jqc.taskManagementEditForm).serialize()) {
                    Utilities.CloseFormWithSaveFirstPrompt().then(r => {
                        if (r == CloseFormEnum.DisregardAndProceed) openForm();
                        else if (r == CloseFormEnum.SaveAndProceed) doSubmit().then(s => { if (s == true) openForm(); });
                    });
                }
                else {
                    openForm();
                }
                function openForm() {
                    events.bus.publish(events.eventOpenTasksAssignPanel([[data], { submitResponse: true }, null]));
                    callback(false); 
                }

                this.blur();
            });

            Utilities.GetControl(jqc.taskManagementContactListBtn).on("click", function () {
                let assignedTo = Utilities.GetControl(jqc.taskManagementEditForm + ' [name="AssignedTo"]').val().toString();
                if (assignedTo == undefined || assignedTo == "") {
                    toastr.error("The task is not assigned to an individual.");
                    return;
                }

                events.bus.publish(events.eventOpenAssignedTasksForm([assignedTo, function (contactRef, contactRefListName) {
                    Utilities.GetControl(jqc.taskManagementEditForm + ' [name="AssignToContactRef"]').val(contactRef);
                    Utilities.GetControl(jqc.taskManagementEditView_assignToField).val(contactRefListName);
                }]));

                this.blur();
            });

            // Show/hide the REVIEW panel
            Utilities.GetControl(jqc.taskManagementEditForm + ' [name = "RequiresReview"]').on("change", function () {
                if (Utilities.GetControl(jqc.taskManagementEditForm + ' [name = "RequiresReview"]').is(":checked") == true) {
                    Utilities.GetControl(jqc.taskManagementTaskEditReviewContainer).show();
                }
                else {
                    Utilities.GetControl(jqc.taskManagementTaskEditReviewContainer).hide();
                }
            });
            if (Utilities.GetControl(jqc.taskManagementEditForm + ' [name = "RequiresReview"]').is(":checked") != true) { Utilities.GetControl(jqc.taskManagementTaskEditReviewContainer).hide(); }

            // Show/hide the INSPECTION panel
            Utilities.GetControl(jqc.taskManagementEditForm + ' [name = "RequiresInspection"]').on("change", function () {
                if (Utilities.GetControl(jqc.taskManagementEditForm + ' [name = "RequiresInspection"]').is(":checked") == true) {
                    Utilities.GetControl(jqc.taskManagementTaskEditInspectionContainer).show();
                }
                else {
                    Utilities.GetControl(jqc.taskManagementTaskEditInspectionContainer).hide();
                }
            });
            if (Utilities.GetControl(jqc.taskManagementEditForm + ' [name = "RequiresInspection"]').is(":checked") != true) { Utilities.GetControl(jqc.taskManagementTaskEditInspectionContainer).hide(); }

            // Get form validation
            Utilities.InitFormValidation(Utilities.GetControl(jqc.taskManagementEditForm));

            function doSubmit() {
                return new Promise<boolean>(function (resolve, reject) {
                    // Validate
                    let form: any = Utilities.GetControl(jqc.taskManagementEditForm);
                    if (form.validate().form() == false) {
                        Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_PleaseEnterAllValues" }]).then(m => {
                            if (m.success == true) toastr.error(m.data[0].value);
                            else toastr.error("Please make sure you have entered all required values.");
                        });
                        resolve(false);
                        return;
                    }

                    Utilities.BlockUI(Utilities.GetControl(jqc.taskManagementRecordListTaskEditContainer));
                    let formData = new FormData(<any>Utilities.GetControl(jqc.taskManagementEditForm)[0]);
                    $.ajax({
                        type: "POST",
                        processData: false,
                        contentType: false,
                        enctype: 'multipart/form-data',
                        url: window.G_SITEFOLDERNAME + '/Tasks/UpdateTask',
                        data: formData,
                        success: function (result: IAPIResult) {
                            try {
                                if (result.success == true) {
                                    toastr.info('Updated task!');
                                    resolve(true);
                                    callback(true);
                                }
                                else {
                                    resolve(false);
                                    toastr.error('Failed to update task!');
                                }
                            }
                            catch (err) {
                                console.log(err);
                                resolve(false);
                            }
                            finally {
                                Utilities.UnBlockUI(Utilities.GetControl(jqc.taskManagementRecordListTaskEditContainer));
                            }
                        }
                    }).fail(function (xhr) {
                        if (xhr.status === 401) {//redirect to login in unauthorised
                            window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                        }
                    });
                });
            }

            Utilities.GetControl(jqc.taskManagementSubmitBtn).on('click', function (evt) {
                evt.preventDefault();

                doSubmit();
            });

            Utilities.GetControl(jqc.taskManagementCancelBtn).on('click', function (evt) {
                if (originalFormData !== Utilities.GetControl(jqc.taskManagementEditForm).serialize()) {
                    Utilities.CloseFormWithSaveFirstPrompt().then(r => {
                        if (r == CloseFormEnum.DisregardAndProceed) callback(false);
                        else if (r == CloseFormEnum.SaveAndProceed) callback(false);
                    });
                }
                else {
                    callback(false);
                }
            });

            Utilities.GetControl(jqc.taskManagementDeleteBtn).on('click', function (evt) {
                events.bus.publish(events.eventDeleteTask([{ code: taskID, featureType: FeatureType.Task }, function (success) {
                    if (success == true) {
                        callback(true);
                    }
                }]));
                
            });

            // Save the original state of the edit form
            var originalFormData = Utilities.GetControl(jqc.taskManagementEditForm).serialize();

        });
    }

    public openTaskGroupEditForm = (taskGroupID: number, callback: Function): void => {
        const self = this;

        Utilities.BlockUI(Utilities.GetControl(jqc.taskManagementRecordListTaskEditContainer));
        Utilities.GetControl(jqc.taskManagementRecordListTaskEditContainer).load(window.G_SITEFOLDERNAME +'/TaskManagement/TaskGroupEdit', { taskGroupID: taskGroupID }, function (response, status, xhr) {
            Utilities.UnBlockUI(Utilities.GetControl(jqc.taskManagementRecordListTaskEditContainer));

            //initialise photo uploader
            self.photos.setupUploader(jqc.taskManagementRecordListTaskEditContainer);

            // Set the assign to value
            var assignToTypeDescr_field = Utilities.GetControl(jqc.taskGroupManagementEditForm + ' [name="AssignToTypeDescr"]');
            var assignToListName_field = Utilities.GetControl(jqc.taskGroupManagementEditForm + ' [name="AssignToContactRefListName"]');
            if (assignToListName_field.val() != "") {
                Utilities.GetControl(jqc.taskGroupManagementEditView_assignToField).val(assignToListName_field.val());
            }
            else {
                Utilities.GetControl(jqc.taskGroupManagementEditView_assignToField).val(assignToTypeDescr_field.val());
            }

            // Show/hide the REVIEW panel
            Utilities.GetControl(jqc.taskGroupManagementEditForm + ' [name = "RequiresReview"]').on("change", function () {
                if (Utilities.GetControl(jqc.taskGroupManagementEditForm + ' [name = "RequiresReview"]').is(":checked") == true) {
                    Utilities.GetControl(jqc.taskGroupManagementTaskEditReviewContainer).show();
                }
                else {
                    Utilities.GetControl(jqc.taskGroupManagementTaskEditReviewContainer).hide();
                }
            });
            if (Utilities.GetControl(jqc.taskGroupManagementEditForm + ' [name = "RequiresReview"]').is(":checked") != true) { Utilities.GetControl(jqc.taskGroupManagementTaskEditReviewContainer).hide(); }

            // Show/hide the INSPECTION panel
            Utilities.GetControl(jqc.taskGroupManagementEditForm + ' [name = "RequiresInspection"]').on("change", function () {
                if (Utilities.GetControl(jqc.taskGroupManagementEditForm + ' [name = "RequiresInspection"]').is(":checked") == true) {
                    Utilities.GetControl(jqc.taskGroupManagementTaskEditInspectionContainer).show();
                }
                else {
                    Utilities.GetControl(jqc.taskGroupManagementTaskEditInspectionContainer).hide();
                }
            });
            if (Utilities.GetControl(jqc.taskGroupManagementEditForm + ' [name = "RequiresInspection"]').is(":checked") != true) { Utilities.GetControl(jqc.taskGroupManagementTaskEditInspectionContainer).hide(); }


            Utilities.GetControl(jqc.taskManagementTaskGroupEditCloseBtn).on('click', function () {
                callback(false);
            });

            Utilities.GetControl(jqc.taskGroupManagementContactListBtn).on("click", function () {
                let assignedTo = Utilities.GetControl(jqc.taskGroupManagementEditForm+ ' [name="AssignToContactRef"]').val().toString();
                events.bus.publish(events.eventOpenAssignedTasksForm([assignedTo, function (contactRef, contactRefListName) {
                    Utilities.GetControl(jqc.taskGroupManagementEditForm + ' [name="AssignToContactRef"]').val(contactRef);
                    Utilities.GetControl(jqc.taskGroupManagementEditView_assignToField).val(contactRefListName);
                }]));
                this.blur();
            });

            // Get form validation
            Utilities.InitFormValidation(Utilities.GetControl(jqc.taskGroupManagementEditForm));

            Utilities.GetControl(jqc.taskGroupManagementSubmitBtn).on('click', function (evt) {
                evt.preventDefault();

                // Validate
                let form: any = Utilities.GetControl(jqc.taskGroupManagementEditForm);
                if (form.validate().form() == false) {
                    Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_PleaseEnterAllValues" }]).then(m => {
                        if (m.success == true) toastr.error(m.data[0].value);
                        else toastr.error("Please make sure you have entered all required values.");
                    });
                    return;
                }

                Utilities.BlockUI(Utilities.GetControl(jqc.taskManagementRecordListTaskEditContainer));
                let formData = new FormData(<any>Utilities.GetControl(jqc.taskGroupManagementEditForm)[0]);
                $.ajax({
                    type: "POST",
                    processData: false,
                    contentType: false,
                    enctype: 'multipart/form-data',
                    url: window.G_SITEFOLDERNAME + '/Tasks/UpdateTaskGroup',
                    data: formData,
                    success: function (result: IAPIResult) {
                        try {
                            if (result.success == true) {
                                toastr.info('Updated task group!');
                                callback(true);
                            }
                            else {
                                toastr.error('Failed to update task group');
                            }
                        }
                        catch (err) {
                            console.log(err);
                            alert(err);
                        }
                        finally {
                            Utilities.UnBlockUI(Utilities.GetControl(jqc.taskManagementRecordListTaskEditContainer));
                        }
                    }
                }).fail(function (xhr) {
                    if (xhr.status === 401) {//redirect to login in unauthorised
                        window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                    }
                });
            });

            Utilities.GetControl(jqc.taskGroupManagementCancelBtn).on('click', function (evt) {
                callback(false);
            });

        });
    }
}




